export default __webpack_public_path__ + "static/media/cnc.c2a47ed9.jpg";